// extracted by mini-css-extract-plugin
module.exports = {"list":"LandList_list__3eOHK"};